export const painPoints: string[] = [
  'Nights lost searching for inspiration on YouTube',
  'Technical plateaus because classes feel repetitive',
  'Hidden anxiety that students (or parents) will notice you aren’t fully prepared',
  'Zero tracking of student progress or improvement',
  'Recital chaos because there’s no system behind you',
  'Weekends stolen planning instead of resting or living your life',
]

export const finalBenefits: string[] = [
  'No more Sunday nights searching for combinations that actually flow',
  'No more classes that feel rushed, repeated, or improvised',
  'No more students who plateau because sessions feel the same every week',
  'No more weekends lost planning instead of living',
  'No more walking into the studio wishing you had prepared more',
  'No more recital chaos when there’s no system behind you',
  'No more guessing whether your students are actually progressing',
]

export interface ValueLine {
  label: string
  value: string
}

export const valueStack: ValueLine[] = [
  { label: 'Ballet Teacher Elite System (6 Volumes)', value: '$97' },
  { label: 'The 7 Strategic Bonus Pack', value: '$100' },
  { label: 'Complete Year-Long Teaching Infrastructure', value: '$127' },
]

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/ue1YBvz6gkfybVwEdfFgTc/ChatGPT_Image_4_sept_2026,_00_35_07-Photoroom.webp'
